import { IsObject } from '../../helpers';
import { CANCELLABLE_PROMISE_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../../misc/helpers/ClassWithPrivateMembers';
import { IsPromiseLikeBase } from '../helpers';
import { NormalizeICancellablePromiseOptions } from './functions';
export function ConstructCancellablePromise(instance, promiseOrCallback, options) {
    ConstructClassWithPrivateMembers(instance, CANCELLABLE_PROMISE_PRIVATE);
    const privates = instance[CANCELLABLE_PROMISE_PRIVATE];
    if (CHECK_CANCELLABLE_PROMISE_CONSTRUCT) {
        const _options = NormalizeICancellablePromiseOptions(options);
        privates.signal = _options.signal;
        privates.strategy = _options.strategy;
        if (typeof promiseOrCallback === 'function') {
            privates.isCancellablePromiseWithSameSignal = false;
            privates.promise = privates.signal.wrapFunction(() => {
                return new Promise((resolve, reject) => {
                    promiseOrCallback.call(instance, resolve, reject, privates.signal);
                });
            }, privates)();
        }
        else if (IsPromiseLikeBase(promiseOrCallback)) {
            privates.isCancellablePromiseWithSameSignal = IsCancellablePromiseWithSameSignal(promiseOrCallback, instance);
            privates.promise = (privates.isCancellablePromiseWithSameSignal
                ? promiseOrCallback
                : privates.signal.wrapPromise(promiseOrCallback, privates));
        }
        else {
            throw new TypeError(`Expected Promise or function as CancellablePromise first argument.`);
        }
    }
    else {
        const _options = options;
        privates.signal = _options.signal;
        privates.strategy = _options.strategy;
        privates.isCancellablePromiseWithSameSignal = IsCancellablePromiseWithSameSignal(promiseOrCallback, instance);
        privates.promise = promiseOrCallback;
    }
}
export function IsCancellablePromise(value) {
    return IsObject(value)
        && value.hasOwnProperty(CANCELLABLE_PROMISE_PRIVATE);
}
export function IsCancellablePromiseWithSameSignal(value, instance) {
    return IsCancellablePromise(value)
        && (value.signal === instance.signal);
}
let CHECK_CANCELLABLE_PROMISE_CONSTRUCT = true;
export function NewCancellablePromise(_constructor, promise, options) {
    CHECK_CANCELLABLE_PROMISE_CONSTRUCT = false;
    const instance = new _constructor(promise, options);
    CHECK_CANCELLABLE_PROMISE_CONSTRUCT = true;
    return instance;
}
export function NewCancellablePromiseFromInstance(instance, promise, options) {
    return NewCancellablePromise(instance.constructor, promise, NormalizeICancellablePromiseOptions(options, instance[CANCELLABLE_PROMISE_PRIVATE]));
}
//# sourceMappingURL=constructor.js.map